import axios from 'axios';
import catchify from 'catchify';
import set from 'lodash/set';

import { getCSRFCookie } from '~/util/global';

const buildApiRequest = (
  axiosInstance = axios,
  url,
  method = 'get',
  data = {},
  headers = { 'Content-Type': 'application/json' },
) => (
  catchify(axiosInstance({
    data,
    url,
    method,
    withCredentials: true,
    headers: {
      'X-CSRFToken': getCSRFCookie(),
      ...headers,
    },
  }))
);

const initialState = () => ({
  error: '',
  isComplete: false,
  isLoading: false,
  isReady: false,
  paymentType: '',
  paymentIntent: null,
});

export const mutations = {
  reset(state) {
    set(state, 'error', '');
    set(state, 'isComplete', false);
    set(state, 'isLoading', false);
    set(state, 'isReady', false);
    set(state, 'paymentType', '');
  },
  setError(state, value) {
    set(state, 'error', value);
  },
  setIsComplete(state, value) {
    set(state, 'isComplete', value);
  },
  setIsLoading(state, value) {
    set(state, 'isLoading', value);
  },
  setIsReady(state, value) {
    set(state, 'isReady', value);
  },
  setPaymentType(state, value) {
    set(state, 'paymentType', value);
  },
  setPaymentIntent(state, value) {
    set(state, 'paymentIntent', value);
  },
};

export const getters = {
  error: (state) => state.error,
  isComplete: (state) => state.isComplete,
  isLoading: (state) => state.isLoading,
  isReady: (state) => state.isReady,
  paymentType: (state) => state.paymentType,
  paymentIntent: (state) => state.paymentIntent,
};

export const actions = {
  onChange({ commit }, event = {}) {
    const {
      value,
      complete,
      error,
    } = event;

    if (value.type) {
      commit('setPaymentType', value.type);
    }

    commit('setIsComplete', complete);
    commit('setError', error);
  },
  async createPaymentIntent({ commit, rootGetters }, uuid) {
    const newPlanSelectedId = rootGetters['changePlan/newPlanSelected']?.id;

    if (!newPlanSelectedId || !uuid) return;

    const data = { uuid, plan_id: newPlanSelectedId };
    const [error, response] = await buildApiRequest(
      this.$axios,
      '/cart/stripe-payment-intent/elements/',
      'post',
      data,
    );

    if (error) {
      commit('setError', error);
    }

    commit('setPaymentIntent', response.data);
  },
};

export { initialState as state };
